import { render } from "./InstructionTips.vue?vue&type=template&id=296f0a8e&scoped=true"
import script from "./InstructionTips.vue?vue&type=script&lang=js"
export * from "./InstructionTips.vue?vue&type=script&lang=js"

import "./InstructionTips.vue?vue&type=style&index=0&id=296f0a8e&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-296f0a8e"]])

export default __exports__